import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../../../graphql";
import PropTypes from "prop-types";
import {
  Typography,
  Row,
  Col,
  Input,
  Form,
  Checkbox,
  Table,
  Radio,
  Select,
  InputNumber,
  DatePicker,
  Tooltip,
  Icon,
} from "antd";
import moment from "moment";
import { changeFormatdate } from "../../../../../../utils/formatdate";
import FromInput from "../../../../../../components/user/from/Input";
import { getExternalsType } from "worker-loader/dist/utils";
import { getToken, urlCommon, urlBenefit } from "../../../../../../utils/auth";
import axios from "axios";
import { apiKeyNews } from "../../../../../../utils/apiKey";
import { numberWithCommas } from "../../../../../../utils/number";
import axiosAPI, { urlAttachFile } from "../../../../../../config/axiosAPI";


const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const newsDataProfile = "";
const format = "HH:mm";
const styles = {
  vertical: {
    verticalAlign: "top",
  },
}
class WelfareListPaymentVictimInDisasterHouse extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    showHomeTypeETC: false,
    dropdownDisasterType: [],
    dropdownAmphor: [],
    dropdownTumbol: [],
    columns: [
      {
        title: "ลำดับ",
        dataIndex: "sort",
        align: "center",
        render: (item, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "ประเภทการประสบภัย",
        dataIndex: "disasterType",
        align: "center",
        width: "180px",
        render: (item, record, index) =>
          this.props.isViewOnly ? (
            <span>{item ? item : "-"}</span>
          ) : (
            <>
              <Form.Item style={{ marginBottom: "0px" }}>
                {this.props.form.getFieldDecorator("disasterTypeId", {
                  initialValue: this.props.rawData.disasterTypeId
                    ? this.props.rawData.disasterTypeId
                    : [],
                  rules: [
                    {
                      required: true,
                      message: "กรุณาเลือกประเภทการประสบภัย",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                    disabled={this.props.isViewOnly}
                    showSearch
                    placeholder="กรุณาเลือก ประเภทการประสบภัย"
                    optionFilterProp="children"
                    onChange={(value) =>
                      this.handleChangeSelectDisasterType(value)
                    }
                  >
                    {console.log(
                      "dropdownDisasterType select",
                      this.state.dropdownDisasterType
                    )}
                    {this.state.dropdownDisasterType.map(
                      (valuesLabel, keys) => {
                        return (
                          <Option value={valuesLabel.id}>
                            {valuesLabel.disasterType}
                          </Option>
                        );
                      }
                    )}
                  </Select>
                )}
              </Form.Item>
              {/* <Form.Item style={{ marginBottom: "0px" }} hidden>
             
             {this.props.form.getFieldDecorator(`mDisasterCondition.id`, {
               initialValue: record.id ? record.id : null,
               rules: [
                 {
                   required: true,
                   message: "กรุณาเลือกประเภทการประสบภัย",
                 },
               ],
             })(
               <Input/>
             )}
           </Form.Item> */}
            </>
          ),
      },
      {
        title: "จำนวนเงินเบิกตามระเบียบ (บาท)",
        dataIndex: "condition",
        align: "center",
        render: (item, record, index) => (
          <>
            <span>
              {this.state.condition
                ? numberWithCommas(this.state.condition)
                : "-"}
            </span>

            <Form.Item className="mb-0" hidden>
              {this.props.form.getFieldDecorator("condition", {
                initialValue: item ? item : 0,
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ จำนวนเงินเบิกตามระเบียบ (บาท)",
                  },
                ],
              })(
                <InputNumber
                  // defaultValue={item}
                  step={1000.01}
                  min={0.0}
                  //max={this.state.disasterCondition}
                  disabled={this.props.isViewOnly || !this.state.isFireType}
                  formatter={(item) =>
                    `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                  onBlur={(value) => this.handleChangeWithdraw(value)}
                  className="input-number"
                />
              )}
            </Form.Item>
          </>
        ),
      },
      {
        title: "มูลค่าความเสียหายที่เกิดขึ้นจริง (บาท)",
        dataIndex: "damageValue",
        align: "center",
        render: (item, record, index) => (
          <>
          {console.log("damageValue item",item)}
            {this.props.isViewOnly ? (
              numberWithCommas(this.props.rawData?.damageValue)
            ) : (
              <>
              <Form.Item className="mb-0 mt-0">
                {this.props.form.getFieldDecorator("damageValue", {
                  initialValue: this.props.rawData?.damageValue ? this.props.rawData?.damageValue : 0,
                  rules: [
                    {
                      required: this.state.isFireType ? true : false,
                      message: "กรุณาระบุ มูลค่าความเสียหายที่เกิดขึ้นจริง",
                    },
                  ],
                })(
                  <InputNumber
                    // defaultValue={item}
                    step={1000.01}
                    min={0.0}
                    //max={this.state.disasterCondition}
                    disabled={this.props.isViewOnly || !this.state.isFireType}
                    formatter={(item) =>
                      `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                    onBlur={(value) => this.handleChangeDamageValue(value)}
                    className="input-number"
                  />
                )}
              </Form.Item>
              {/* <span style={{ fontSize: "18px" }}>
              ข้อมูลการเบิกเงินสวัสดิการ - บ้านประสบภัยพิบัติ
            </span> */}
            </>
            )}
          </>
        ),
      },
      {
        title: "จำนวนเงินที่เบิกได้จริง (บาท)",
        dataIndex: "totalCurrentWithdraw",
        align: "center",
        render: (item, record, index) => (
         <>
         {console.log("totalcurrent item",item)}
            {this.props.isViewOnly ? (
              numberWithCommas(this.props.rawData?.totalCurrentWithdraw)
            ) : (
              <Form.Item className="mb-0 mt-0">
                {this.props.form.getFieldDecorator("totalCurrentWithdraw", {
                  initialValue: this.props.rawData?.totalCurrentWithdraw
                    ? this.props.rawData?.totalCurrentWithdraw
                    : 0,
                  //   getValueFromEvent: value =>{
                  //     return value && value !== '0' && value !== '-' ? value : ''
                  // },
                  rules: [
                    {
                      required: true,
                      message: "กรุณาระบุ  จำนวนเงินที่เบิกได้จริง",
                    },
                  ],
                })(
                  <InputNumber
                    // defaultValue={item}
                    step={1000.01}
                    min={0.0}
                    max={
                      this.state.isFireType
                        ? this.state.condition &&
                          this.state.damageValueNumber
                        : this.state.condition
                    }
                    disabled={this.props.isViewOnly}
                    formatter={(item) =>
                      `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(item) => item.replace(/\$\s?|(,*)/g, "")}
                    onBlur={(value) => this.handleChangeWithdraw(value)}
                    className="input-number"
                  />
                )}
              </Form.Item>
            )}
          </>
        ),
      },
    ],
  };

  handleChangeRadioETC = async (value) => {
    const { form } = this.props;
    console.log("handleChangeRadioETC", value.target.value);
    if (value.target.value == "other") {
      console.log("handleChangeRadioETC iffff", value.target.value);
      await this.setState({
        showHomeTypeETC: true,
        showHomeOwner: true,
      });
    } else {
      console.log("handleChangeRadioETC elsee", value.target.value);
      await this.setState({
        showHomeTypeETC: false,
      });

      if (value.target.value != "owner") {
        console.log("handleChangeRadioETC iffff", value.target.value);
        await this.setState({
          showHomeOwner: true,
        });
      } else {
        console.log("handleChangeRadioETC elsee", value.target.value);
        await this.setState({
          showHomeOwner: false,
        });
      }

      await form.setFieldsValue({
        homeDescription: "",
        ownerName: "",
      });
    }
  };
  handleChangeSelectDisasterType = (value) => {
    const { form } = this.props;
    const { dropdownDisasterType } = this.state;
    console.log("value handleChangeSelectDisasterType", value);

    dropdownDisasterType.map(async (valuesTable, keysTable) => {
      if (valuesTable.id == value) {
        await this.setState({
          condition: valuesTable.condition,
        });
        form.setFieldsValue({
          condition: valuesTable.condition,
          totalCurrentWithdraw: valuesTable.condition,
          damageValue: valuesTable.condition,
        });
        this.setState({
          totalWithdraw: numberWithCommas(valuesTable.condition),
        });
      }
    });

    if (value == 1) {
      this.setState({
        isFireType: true,
      });
    } else {
      this.setState({
        isFireType: false,
      });
    }

    const fieldsBeforeMap = this.props.form.getFieldsValue();

    console.log(
      "fieldsBeforeMap handleChangeSelectDisasterType",
      fieldsBeforeMap
    );
  };

  handleChangeWithdraw = (value) => {
    const { form } = this.props;
    const { dropdownDisasterType, damageValueNumber } = this.state;
    console.log("value handleChangeWithdraw eiei", value.target.value);

    console.log(
      "totalCoditionValue eiei",
      this.props.form.getFieldValue("totalCurrentWithdraw")
    );

    if (value.target.value == "") {
      form.setFieldsValue({
        totalCurrentWithdraw: 0,
      });
    }
    let totalCoditionValue = this.props.form.getFieldValue(
      "totalCurrentWithdraw"
    );
    console.log("float total withdraw", totalCoditionValue)

    let damageValueField = this.props.form.getFieldValue("damageValue");
    let conditionField = this.props.form.getFieldValue("condition");

    if (
      parseFloat(value.target.value.replace(/,/g, "")) > conditionField ||
      parseFloat(value.target.value.replace(/,/g, "")) > damageValueField
    ) {
      if (damageValueField < conditionField) {
        console.log("damageValueField  < totalCoditionValue",damageValueField)
        form.setFieldsValue({
          totalCurrentWithdraw: damageValueField,
        });
        this.setState({
          totalWithdraw: damageValueField,
        });
      } else if (damageValueField > conditionField) {
        console.log("damageValueField > totalCoditionValue",conditionField)

        form.setFieldsValue({
          totalCurrentWithdraw: conditionField,
        });

        this.setState({
          totalWithdraw: numberWithCommas(conditionField),
        });
      } else {
        console.log("damageValueField > totalCoditionValue",totalCoditionValue)
        form.setFieldsValue({
          totalCurrentWithdraw: 0,
        });
        this.setState({
          totalWithdraw: 0,
        });
      }
    }
    else{
     form.setFieldsValue({
      totalCurrentWithdraw: totalCoditionValue,
    });
    this.setState({
      totalWithdraw: numberWithCommas(totalCoditionValue),
    }); 
    }

    
  };

  handleChangeDamageValue = (value) => {
    const { form } = this.props;
    const { dropdownDisasterType } = this.state;


    if (value.target.value == "") {
      form.setFieldsValue({
        damageValue: 0,
      });
    }

    let totalCoditionValue = this.props.form.getFieldValue(
      "totalCurrentWithdraw"
    );

    if (parseFloat(value.target.value.replace(/,/g, "")) < totalCoditionValue) {
      form.setFieldsValue({
        totalCurrentWithdraw: parseFloat(value.target.value.replace(/,/g, "")),
      });
      this.setState({
        totalWithdraw: value.target.value,
      }); 
    }
    this.setState({
      damageValueNumber: parseFloat(value.target.value.replace(/,/g, "")),
    });
  };

  handleChangeSelectProvince = (value) => {
    const { form, rawData } = this.props;
    const { dropdownDisasterType } = this.state;
    console.log("value handleChangeSelectProvince", value);
  };

  setCondition = (value) => {
    const { form, rawData } = this.props;
    const { dropdownDisasterType } = this.state;
    console.log("value setCondition", value);
    console.log(
      "value setCondition rawData.disasterType",
      rawData.disasterType
    );

    value.map(async (valuesTable, keysTable) => {
      if (valuesTable.disasterType == rawData.mDisasterCondition.disasterType) {
        console.log("value setCondition in condition", value);
        console.log(
          "value setCondition valuesTable.condition",
          valuesTable.condition
        );
        this.setState({
          condition: valuesTable.condition,
        });
        await form.setFieldsValue({
          damageValue: valuesTable.condition,
        });
      }
    });
  };

  onChangeDropdownTumbol = (value) => {
    const { form, rawData } = this.props;
    const { dropdownTumbol } = this.state;
    console.log("value onChangeDropdownTumbol", value);
    console.log("dropdownTumbol", dropdownTumbol);

    dropdownTumbol.map(async (valuesTable, keysTable) => {
      if (valuesTable.tumbolCode == value) {
        console.log("value onChangeDropdownTumbol in condition", value);
        await form.setFieldsValue({
          postCode: value,
        });

        await this.setState({
          disabledPostcode: false,
        });
      }
    });
  };

  onChangeDropdownAmphur = (value) => {
    const { form, rawData } = this.props;
    const { dropdownTumbol } = this.state;
    console.log("value onChangeDropdownTumbol", value);
    console.log("dropdownTumbol", dropdownTumbol);

    this.setState({
      disabledPostcode: true,
    });
    form.setFieldsValue({
      postCode: null,
      subDistrict: null,
    });
  };

  geteDropdownCountry = async () => {
    const { token } = getToken();
    const { match } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

   //  axios
   //    .get(
   //      `https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/address/listAllProvince/`,
   //      {},
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response.data country", response.data);
   //      if (response.data) {
   //        await this.setState({
   //          dropdownCountry: response.data.provinces,
   //          //isEdit: response.data.data.approveStatus == "draft" ? true : false,
   //        });
   //      }
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));

   console.log('urlCommon')
      const DataFetchAPI = await axiosAPI.get(`
         ${urlCommon()}address/listAllProvince/`, 
      );

      console.log("DataFetchAPI province", DataFetchAPI);

      if (DataFetchAPI.data) {
         await this.setState({
            dropdownCountry: DataFetchAPI.data.provinces,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
         });
      } else {
        await this.setState({
          loadingFullpage: false,
        });
      }
  };

  geteDropdownAmphor = async (valueProvCode, initial) => {
    const { token } = getToken();
    const { match, form } = this.props;

    console.log("valueProvCode", valueProvCode);

    if (initial != "initial") {
      await form.setFieldsValue({
        district: null,
        subDistrict: null,
        postCode: null,
      });
      await this.setState({
        disabledPostcode: true,
      });
    }

    await this.setState({
      provinceCodeChange: valueProvCode,
      dropdownAmphor: [],
      dropdownTumbol: [],
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

   //  axios
   //    .get(
   //      `https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/address/listAumphur/`,
   //      {
   //        params: {
   //          provCode: valueProvCode,
   //        },
   //      },
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response.data aumphurs", response.data);
   //      if (response.data) {
   //        const filterAumphor = response.data.aumphurs.filter(
   //          (obj, index) =>
   //            response.data.aumphurs.findIndex(
   //              (item) => item.amphCode === obj.amphCode
   //            ) === index
   //        );

   //        await this.setState({
   //          dropdownAmphor: filterAumphor,
   //          //isEdit: response.data.data.approveStatus == "draft" ? true : false,
   //        });
   //      }
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));

   const DataFetchAPI = await axiosAPI.get(`
         ${urlCommon()}address/listAumphur/`, 
         {
            params: { provCode: valueProvCode, }
         },
      );

      console.log("DataFetchAPI aumphurs", DataFetchAPI);

      if (DataFetchAPI.data) {
         const filterAumphor = DataFetchAPI.data.aumphurs.filter(
            (obj, index) =>
               DataFetchAPI.data.aumphurs.findIndex(
                  (item) => item.amphCode === obj.amphCode
               ) === index
            );

            await this.setState({
               dropdownAmphor: filterAumphor,
               //isEdit: DataFetchAPI.data.data.approveStatus == "draft" ? true : false,
            });
      } else {
        await this.setState({
         dropdownAmphor: [],
        });
      }
  };

  geteDropdownTumbol = async (valueProvCode, valueDistrictCode, initial) => {
    const { token } = getToken();
    const { match, form } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    if (initial != "initial") {
      await form.setFieldsValue({
        subDistrict: null,
        postCode: null,
      });
      await this.setState({
        disabledPostcode: true,
      });
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

   //  axios
   //    .get(
   //      `https://uat-vtrcapi.redcross.or.th/vtrc-common/api/v1/address/listTumbol/`,
   //      {
   //        params: {
   //          provCode: valueProvCode,
   //          amphCode: valueDistrictCode,
   //        },
   //      },
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response.data tumbol", response.data);
   //      if (response.data) {
   //        await this.setState({
   //          dropdownTumbol: response.data.tumbols,
   //          //isEdit: response.data.data.approveStatus == "draft" ? true : false,
   //        });
   //      }
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));

      const DataFetchAPI = await axiosAPI.get(`
         ${urlCommon()}address/listTumbol/`, 
         {
            params: { 
               provCode: valueProvCode,
               amphCode: valueDistrictCode,
            }
         },
      );

      console.log("DataFetchAPI history", DataFetchAPI);

      if (DataFetchAPI.data) {
         await this.setState({
            dropdownTumbol: DataFetchAPI.data.tumbols,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
         });
      } else {
      //   await this.setState({
      //       dropdownTumbol: [],
      //   });
      }
  };

  geteDropdownDisasterType = async () => {
    const { token } = getToken();
    const { match } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

   //  axios
   //    .get(
   //      `https://uat-vtrcapi.redcross.or.th/benefit-api/api/v1/disaster/get_disaster_condition/`,
   //      {},
   //      {
   //        headers: headers,
   //      }
   //    )
   //    .then(async (response) => {
   //      console.log("response.data disastertype", response.data);
   //      if (response.data) {
   //        await this.setState({
   //          dropdownDisasterType: response.data,
   //          //isEdit: response.data.data.approveStatus == "draft" ? true : false,
   //        });
   //        await this.setCondition(response.data);
   //      }
   //    })
   //    .catch((error) => console.error(`Error: ${error}`));
         const DataFetchAPI = await axiosAPI.get(`
            ${urlBenefit()}disaster/get_disaster_condition/`, 
         );

         console.log("DataFetchAPI history", DataFetchAPI);

         if (DataFetchAPI.data) {
            await this.setState({
               dropdownDisasterType: DataFetchAPI.data,
               //isEdit: DataFetchAPI.data.data.approveStatus == "draft" ? true : false,
            });
            await this.setCondition(DataFetchAPI.data);
         } else {
         //   await this.setState({
         //       dropdownTumbol: [],
         //   });
         }
  };

  dateFormatNumber = (values) => {
    const { form } = this.props;

    console.log("valueReturn values", values);
    let valueReturn = changeFormatdate(moment(form.getFieldValue(values)));
    console.log("valueReturn", valueReturn);

    return valueReturn;
  };

  disabledDate = (current) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    let dateSubmit = form.getFieldValue("submitDate");

    console.log("dateSubmit", dateSubmit);
    console.log("current", current);
    return current && current > dateSubmit;
  };

  disabledApprovePaymentDate = (current) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    let dateSubmit = form.getFieldValue("submitDate");

    console.log("dateSubmit", dateSubmit);
    console.log("current", current);
    return current < dateSubmit || current >= moment();
  };

  disabledEndDate = (current) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    let dateStart = form.getFieldValue("disasterStartDate");
    let dateSubmit = form.getFieldValue("submitDate");

    console.log("dateSubmit", dateSubmit);
    console.log("current", current);
    return current < dateStart || current > dateSubmit;
  };

  disabledWarrantyDate = (current) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    let dateSubmit = form.getFieldValue("submitDate");
    return current && current > dateSubmit;
  };

  onChangeSubmitDate = (value) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    console.log("value onChangeSubmitDate", value);

    this.setState({
      disabledStartDate: value,
      disabledWarrantyDate: value,
    });

    let dateStartDisaster = form.getFieldValue("disasterStartDate");
    let dateEndDisaster = form.getFieldValue("disasterEndDate");
    let Datewarranty = form.getFieldValue("warrantyDate");
    let DateApprovePayment = form.getFieldValue("approvePaymentDate");
    let DatePayment = form.getFieldValue("paymentDate");

    if (moment(dateStartDisaster).isAfter(value)) {
      form.setFieldsValue({
        disasterStartDate: value,
        disasterEndDate: value,
      });
    } else if (moment(dateEndDisaster).isAfter(value)) {
      form.setFieldsValue({
        disasterEndDate: dateStartDisaster,
      });
    }

    if (Datewarranty) {
      if (moment(Datewarranty).isBefore(value)) {
        form.setFieldsValue({
          warrantyDate: value,
        });
      }
    }

    if (DateApprovePayment) {
      if (moment(DateApprovePayment).isBefore(value)) {
        form.setFieldsValue({
          approvePaymentDate: value,
        });
      }
    }
    if (DatePayment) {
      if (moment(DateApprovePayment).isBefore(value)) {
        form.setFieldsValue({
          approvePaymentDate: value,
        });
      }
    }
  };

  onChangeStartDate = (value) => {
    //const { disabledDateStart } = this.state;
    const { form } = this.props;

    console.log("value onChangeStartDate", value);

    let dateEndDisaster = form.getFieldValue("disasterEndDate");

    if (moment(dateEndDisaster).isBefore(value)) {
      form.setFieldsValue({
        disasterEndDate: value,
      });
    }
  };

  async componentDidMount() {
    const { rawData } = this.props;
    const { dropdownDisasterType, dropdownCountry } = this.state;

    await this.geteDropdownDisasterType();
    await this.geteDropdownCountry();

    console.log("hi dropdownDisasterType", dropdownDisasterType);

    console.log("rawData inhouse eiei", rawData);

    if (rawData) {
      let arrayDisaster = [];
      arrayDisaster.push(rawData.mDisasterCondition);

      console.log("arrayDisaster", arrayDisaster);
      await this.setState({
        dataTableDisaster: arrayDisaster,
      });

      if (rawData?.homeType == "other") {
        await this.setState({
          showHomeTypeETC: true,
        });
      } else {
        await this.setState({
          showHomeTypeETC: false,
        });
      }

      if (rawData?.homeType != "owner") {
        await this.setState({
          showHomeOwner: true,
        });
      } else {
        await this.setState({
          showHomeOwner: false,
        });
      }

      if (rawData?.disasterTypeId == 1) {
        await this.setState({
          isFireType: true,
        });
      }
      await this.setState({
        totalWithdraw: numberWithCommas(rawData?.totalCurrentWithdraw),
      });

      await this.geteDropdownAmphor(rawData.province, "initial");
      await this.geteDropdownTumbol(
        rawData.province,
        rawData.district,
        "initial"
      );
    }
  }

  render() {
    const { match, rawData, isViewOnly, isApproveMode } = this.props;
    const {
      loadingFullpage,
      columns,
      showHomeTypeETC,
      showHomeOwner,
      dataTableDisaster,
      totalWithdraw,
    } = this.state;
    //const { getFieldDecorator } = this.props.form;
    const testInfo =
      '<p class="mb-2">วันที่ผู้อำนวยการสำนักงานบริหารทรัพยากรบุคคลลงนามอนุมัติการเบิกจ่าย</p>';
    console.log("rawData inhouse render", rawData);
    return (
      <>
        <Row
          gutter={16}
          type="flex"
          justify="left"
          align="top"
          className="py-2"
        >
          <Col md={24} className="mb-3">
            <Text className="color-red">
              <span style={{ fontSize: "18px" }}>
                ข้อมูลการเบิกเงินสวัสดิการ - บ้านประสบภัยพิบัติ
              </span>
            </Text>
          </Col>

          {isApproveMode && (
            <Col md={24} className="" style={{ padding: "0px" }}>
              <Col md={12} className="mb-2" hidden>
                <Form.Item label={"รอบจ่ายเงิน"} className="mb-0" hidden>
                  {this.props.form.getFieldDecorator("paymentDate", {
                    initialValue: rawData?.paymentDate
                      ? moment(rawData?.paymentDate)
                      : null,
                    rules: [
                      {
                        required: false,
                        message: "กรุณาระบุ  รอบจ่ายเงิน",
                      },
                    ],
                  })(
                    <DatePicker
                      disabledDate={this.disabledApprovePaymentDate}
                      disabled={this.props.isViewOnly}
                      format={this.dateFormatNumber(`paymentDate`)}
                      className="w-100"
                      placeholder="เลือกวันที่"
                      allowClear={false}
                    />
                  )}
                </Form.Item>
              </Col>
            </Col>
          )}

          <Col md={12} className="mb-2">
            <Form.Item label={"วันที่ยื่นเอกสาร"} className="mb-0">
              {this.props.form.getFieldDecorator("submitDate", {
                initialValue: rawData?.submitDate
                  ? moment(rawData?.submitDate)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ วันที่ยื่นเอกสาร",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={(current) => {
                    return moment() <= current;
                  }}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`submitDate`)}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  allowClear={false}
                  onChange={(e) => this.onChangeSubmitDate(e)}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label={"วันที่อนุมัติเบิกจ่าย"} className="mb-0">
              <Tooltip
                placement="top"
                title={<div dangerouslySetInnerHTML={{ __html: testInfo }} />}
              >
                <Icon
                  type="info-circle"
                  style={{ position: "absolute", left: "130px", top: "-37px" }}
                />
              </Tooltip>
              {this.props.form.getFieldDecorator("approvePaymentDate", {
                initialValue: rawData?.approvePaymentDate
                  ? moment(rawData?.approvePaymentDate)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ วันที่อนุมัติเบิกจ่าย",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={this.disabledApprovePaymentDate}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`approvePaymentDate`)}
                  className="w-100"
                  placeholder="วันที่อนุมัติเบิกจ่าย"
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label={"วันที่เริ่มต้นประสบภัยพิบัติ"} className="mb-0">
              {this.props.form.getFieldDecorator("disasterStartDate", {
                initialValue: rawData?.disasterStartDate
                  ? moment(rawData?.disasterStartDate)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ วันที่เริ่มต้นประสบภัยพิบัติ",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={this.disabledDate}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`disasterStartDate`)}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  allowClear={false}
                  onChange={(e) => this.onChangeStartDate(e)}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Item label={"วันที่สิ้นสุดประสบภัยพิบัติ"} className="mb-0">
              {this.props.form.getFieldDecorator("disasterEndDate", {
                initialValue: rawData?.disasterEndDate
                  ? moment(rawData?.disasterEndDate)
                  : null,
                rules: [
                  {
                    required: true,
                    message: "กรุณาระบุ วันที่สิ้นสุดประสบภัยพิบัติ",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={this.disabledEndDate}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`disasterEndDate`)}
                  className="w-100"
                  placeholder="เลือกวันที่"
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={24} className="">
            <Row
              gutter={16}
              type="flex"
              justify="left"
              align="top"
              className=""
            >
              <Col className="" style={{ width: "480px" }}>
                <Form.Item
                  label={"สถานภาพการพักอาศัย"}
                  style={{ width: "480px" }}
                >
                  {this.props.form.getFieldDecorator("homeType", {
                    initialValue: rawData?.homeType
                      ? rawData?.homeType
                      : "owner",
                    rules: [
                      {
                        required: true,
                        message: "กรุณากรอกหรือเลือก ",
                      },
                    ],
                  })(
                    <Radio.Group
                      disabled={isViewOnly}
                      onChange={(e) => {
                        this.handleChangeRadioETC(e);
                      }}
                    >
                      <Radio value={"owner"}>เจ้าบ้าน</Radio>
                      <Radio value={"lodger"}>ผู้อาศัยในทะเบียนบ้าน</Radio>
                      <Radio value={"renter"}>ผู้เช่าบ้าน</Radio>
                      <Radio value={"other"}>อื่นๆ (ระบุ)</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Col>
              {showHomeTypeETC && (
                <Col md={8} className="mb-2">
                  <Form.Item label="" className="mb-0">
                    {this.props.form.getFieldDecorator("homeDescription", {
                      initialValue: rawData?.homeDescription
                        ? rawData?.homeDescription
                        : "",
                      rules: [
                        {
                          required: showHomeTypeETC ? true : false,
                          message: "กรุณาระบุ รายละเอียดที่อยู่ประเภทอื่นๆ",
                        },
                      ],
                    })(
                      <Input
                        className="w-100"
                        placeholder="ระบุ รายละเอียดที่อยู่ประเภทอื่นๆ"
                        disabled={isViewOnly}
                        allowClear={false}
                        style={{ marginTop: "40px" }}
                      />
                    )}
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Col>
          {showHomeOwner && (
            <Col md={12} className="mb-2">
              <Form.Item label="เจ้าบ้าน/ผู้รับรอง" className="mb-0">
                {this.props.form.getFieldDecorator("ownerName", {
                  initialValue: rawData?.ownerName ? rawData?.ownerName : "",
                  rules: [
                    {
                      required: showHomeOwner ? true : false,
                      message: "กรุณาระบุ เจ้าบ้าน/ผู้รับรอง",
                    },
                  ],
                })(
                  <Input
                    className="w-100"
                    placeholder="ระบุ เจ้าบ้าน/ผู้รับรอง"
                    disabled={isViewOnly}
                    allowClear={false}
                  />
                )}
              </Form.Item>
            </Col>
          )}

          <Row
            gutter={16}
            type="flex"
            justify="left"
            align="top"
            style={{ width: "100%", marginLeft: "0px" }}
          >
            <Col md={12} className="mb-2">
              <Form.Item
                label={"เลขรหัสประจำบ้าน (ในสำเนาทะเบียนบ้าน)"}
                className="mb-0"
              >
                {this.props.form.getFieldDecorator("homeNo", {
                  initialValue: rawData?.homeNo ? rawData?.homeNo : null,
                  rules: [
                    {
                      required: true,
                      message:
                        "กรุณาระบุ เลขรหัสประจำบ้าน (ในสำเนาทะเบียนบ้าน)",
                    },
                  ],
                })(
                  <InputNumber
                    placeholder="ระบุ เลขรหัสประจำบ้าน (ในสำเนาทะเบียนบ้าน)"
                    disabled={isViewOnly}
                    style={{ textAlign: "left" }}
                  />
                )}
              </Form.Item>
            </Col>

            <Col md={12} className="mb-2">
              <Form.Item label={"รายละเอียดที่อยู่"} className="mb-0">
                {this.props.form.getFieldDecorator("address", {
                  initialValue: rawData?.address ? rawData?.address : "",
                  rules: [
                    {
                      required: false,
                      message: "กรุณาระบุ รายละเอียดที่อยู่",
                    },
                  ],
                })(
                  <Input
                    className="w-100"
                    placeholder="ระบุ รายละเอียดที่อยู่"
                    disabled={isViewOnly}
                    allowClear={false}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Col md={12} className="mb-2">
            {this.state.dropdownCountry && (
              <Form.Item label={"จังหวัด"} style={{ marginBottom: "0px" }}>
                {this.props.form.getFieldDecorator("province", {
                  initialValue: rawData?.province ? rawData?.province : [],
                  rules: [
                    {
                      required: false,
                      message: "กรุณาเลือก จังหวัด",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                    disabled={this.props.isViewOnly}
                    showSearch
                    placeholder="กรุณาเลือก จังหวัด"
                    optionFilterProp="children"
                    onChange={(value) =>
                      this.geteDropdownAmphor(value, "not initial")
                    }
                  >
                    {console.log(
                      "dropdownCountry select ttt",
                      this.state.dropdownCountry
                    )}
                    {this.state.dropdownCountry.map((valuesLabel, keys) => {
                      return (
                        <Option value={valuesLabel.provCode} key={keys}>
                          {valuesLabel.provName}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            )}
          </Col>

          <Col md={12} className="mb-2">
            {this.state.dropdownCountry && (
              <Form.Item label={"เขต/อำเภอ"} style={{ marginBottom: "0px" }}>
                {this.props.form.getFieldDecorator("district", {
                  initialValue: rawData?.district ? rawData?.district : [],
                  rules: [
                    {
                      required: false,
                      message: "กรุณาเลือก เขต/อำเภอ",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                    disabled={
                      this.props.isViewOnly ||
                      this.state.dropdownAmphor.length == 0
                    }
                    showSearch
                    placeholder="กรุณาเลือก เขต/อำเภอ"
                    optionFilterProp="children"
                    onChange={(value) =>
                      this.geteDropdownTumbol(
                        this.state.provinceCodeChange,
                        value,
                        "not initial"
                      )
                    }
                  >
                    {console.log(
                      "dropdownAmphor select ttt",
                      this.state.dropdownAmphor
                    )}
                    {this.state.dropdownAmphor?.map((valuesLabel, keys) => {
                      return (
                        <Option value={valuesLabel.amphCode} key={keys}>
                          {valuesLabel.amphName}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            )}
          </Col>

          <Col md={12} className="mb-2">
            {this.state.dropdownCountry && (
              <Form.Item label={"แขวง/ตำบล"} style={{ marginBottom: "0px" }}>
                {this.props.form.getFieldDecorator("subDistrict", {
                  initialValue: rawData?.subDistrict
                    ? rawData?.subDistrict
                    : [],
                  rules: [
                    {
                      required: false,
                      message: "กรุณาเลือก แขวง/ตำบล",
                    },
                  ],
                })(
                  <Select
                    style={{ width: "100%" }}
                    // onChange={ (e) => this.onChangeValueForm(index, e, 'documentType') }
                    disabled={
                      this.props.isViewOnly ||
                      this.state.dropdownTumbol.length == 0
                    }
                    showSearch
                    placeholder="กรุณาเลือก แขวง/ตำบล"
                    optionFilterProp="children"
                    onChange={(value) => this.onChangeDropdownTumbol(value)}
                  >
                    {console.log(
                      "dropdownAmphor select ttt",
                      this.state.dropdownTumbol
                    )}
                    {this.state.dropdownTumbol?.map((valuesLabel, keys) => {
                      return (
                        <Option value={valuesLabel.tumbolCode} key={keys}>
                          {valuesLabel.tumbolName}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            )}
          </Col>

          <Col md={12} className="mb-2">
            <Form.Item label={"รหัสไปรษณีย์"} className="mb-0">
              {this.props.form.getFieldDecorator("postCode", {
                initialValue: rawData?.postCode ? rawData?.postCode : "-",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ  รหัสไปรษณีย์",
                  },
                ],
              })(
                <Input
                  //format={this.dateFormatNumber("leaveStartDate")}
                  //   disabledDate={this.disabledDateInputFirst}
                  className="w-100"
                  placeholder="ระบุ รหัสไปรษณีย์"
                  disabled={
                    this.props.isViewOnly || this.state.disabledPostcode
                  }
                  allowClear={false}
                  // onBlur={(value) => this.handleChangeWithdraw(value)}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={24} className="mb-2">
            <Form.Item className="mb-0" valuePropName={"checked"}>
              {this.props.form.getFieldDecorator("isOtherPeople", {
                initialValue: rawData?.isOtherPeople == 1 ? true : false,
                rules: [
                  {
                    required: false,
                    message: "กรุณากรอกหรือเลือก ",
                  },
                ],
              })(
                <Checkbox
                  //checked={rawData?.isOtherPeople == 1 || rawData?.isOtherPeople ? true : false}
                  defaultChecked={
                    rawData?.isOtherPeople == 1 || rawData?.isOtherPeople
                      ? true
                      : false
                  }
                  disabled={isViewOnly}
                >
                  มีผู้ปฏิบัติงานอยู่ในสภากาชาดไทยและพักอาศัยอยู่ด้วยกันในบ้านซึ่งประสบภัยพิบัติ
                  (ระบุ):
                </Checkbox>
              )}
            </Form.Item>
            <Form.Item className="mb-0">
              {this.props.form.getFieldDecorator("otherPeople", {
                initialValue: rawData?.otherPeople ? rawData?.otherPeople : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณากรอก ",
                  },
                ],
              })(
                <TextArea
                  //value={rawData?.otherPeople ? rawData?.otherPeople : "-"}
                  placeholder=""
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  disabled={isViewOnly}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8} className="mb-2">
            <Form.Item label={"หน่วยงานที่ออกหนังสือรับรอง"} className="mb-0">
              {this.props.form.getFieldDecorator("orgWarranty", {
                initialValue: rawData?.orgWarranty ? rawData?.orgWarranty : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ หน่วยงานที่ออกหนังสือรับรอง",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ หน่วยงานที่ออกหนังสือรับรอง"
                  disabled={isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8} className="mb-2">
            <Form.Item label={"เลขที่"} className="mb-0">
              {this.props.form.getFieldDecorator("warrantyNo", {
                initialValue: rawData?.warrantyNo ? rawData?.warrantyNo : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ เลขที่",
                  },
                ],
              })(
                <Input
                  className="w-100"
                  placeholder="ระบุ เลขที่"
                  disabled={isViewOnly}
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>
          <Col md={8} className="mb-2">
            <Form.Item label={"ลงวันที่"} className="mb-0">
              {this.props.form.getFieldDecorator("warrantyDate", {
                initialValue: rawData?.warrantyDate
                  ? moment(rawData?.warrantyDate)
                  : null,
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ ลงวันที่",
                  },
                ],
              })(
                <DatePicker
                  disabledDate={this.disabledWarrantyDate}
                  disabled={this.props.isViewOnly}
                  format={this.dateFormatNumber(`warrantyDate`)}
                  className="w-100"
                  placeholder="ลงวันที่"
                  allowClear={false}
                />
              )}
            </Form.Item>
          </Col>

          <Col md={24} className="mb-2">
            <Form.Item label={"ประเภทการประสบภัยพิบัติ"} className="mb-0" />
            <Table
              locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
              columns={columns}
              dataSource={dataTableDisaster}
              pagination={false}
              style={{verticalAlign:"top"}}
              verticalAlign='top'
              rowClassName={(record, index) => index != 0 ? 'style.vertical' :  'table-row-dark'}
            />
          </Col>
          <Col xs={24} md={24} align="right" style={{ textAlign: "right" }}>
            รวมยอดเงินที่เบิกได้จริง {totalWithdraw} บาท
            {/* 
            <Form.Item className="mb-0" hidden>
        { this.props.form.getFieldDecorator('totalCurrentWithdraw', {
           initialValue: rawData.totalCurrentWithdraw ? rawData.totalCurrentWithdraw : 0.00,
           
        })(
           
           <InputNumber 
           // defaultValue={item}
           step={1000.01}
           min={0.00}
           disabled={this.props.isViewOnly}
           formatter={item => `${item}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
           parser={item => item.replace(/\$\s?|(,*)/g, '')}
           className="input-number"
       />
        )}
  </Form.Item> */}
            {/* <Button
                              className="btn-color-default color-white ml-3"
                              type="primary "
                              htmlType="submit"
                              onClick={this.personnelHistoryReport}
                           >
                              รายงานประวัติการพัฒนาบุคลากร
                           </Button> */}
          </Col>

          <Col md={24} className="mb-2">
            <Form.Item label={"รายละเอียดความเสียหาย"} className="mb-0">
              {this.props.form.getFieldDecorator("disasterDetail", {
                initialValue: rawData?.disasterDetail
                  ? rawData?.disasterDetail
                  : "",
                rules: [
                  {
                    required: false,
                    message: "กรุณาระบุ รายละเอียดความเสียหาย",
                  },
                ],
              })(
                <TextArea
                  // value={rawData?.disasterDetail ? rawData?.disasterDetail : "-"}
                  placeholder=""
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  disabled={isViewOnly}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  }
}

WelfareListPaymentVictimInDisasterHouse.defaultProps = {
  autoFocus: false,
};

WelfareListPaymentVictimInDisasterHouse.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListPaymentVictimInDisasterHouse = Form.create()(
  WelfareListPaymentVictimInDisasterHouse
);

export default withApollo(WrappedWelfareListPaymentVictimInDisasterHouse);
